import React from 'react';
import classnames from 'classnames';
import styles from './Badge.scss';
var Badge = function (_a) {
    var badgeTitle = _a.title, description = _a.description, stackCount = _a.stackCount, name = _a.name, images = _a.images, className = _a.className, _b = _a.size, size = _b === void 0 ? 'large' : _b;
    var title = badgeTitle;
    if (description) {
        title += ": ".concat(description);
    }
    if (stackCount) {
        title += " (".concat(stackCount, ")");
    }
    return (React.createElement("div", { className: classnames(styles['root'], styles["badge-".concat(name)], styles["size-".concat(size)], className), title: title }, images.map(function (image, index) {
        var imageClassnames = image.className
            ? image.className.split(' ')
            : [];
        return (React.createElement("img", { key: index, src: image.imageUrl, className: classnames(styles['badge-image'], imageClassnames.map(function (c) { return styles[c]; })), alt: title, loading: "lazy" }));
    })));
};
Badge.displayName = 'Badge';
export default Badge;
//# sourceMappingURL=Badge.js.map